// client/src/components/forms/DateTimePicker.js
//
// Native <input type="datetime-local"> for v1. Mobile handles its own
// picker sheet; desktop shows the platform's inline picker. Saves us
// building a real picker before we need one.
//
// Same visual treatment as TextInput (single rule border, paper bg,
// ink text, ice focus ring) so pickers and text inputs live together
// in a form without feeling like different species.
//
// Value format is the datetime-local ISO-ish string, e.g.
// "2026-08-15T18:30" — no seconds, no timezone. Callers that need
// UTC for the server should convert on submit, not here.

export function DateTimePicker({
  value,
  onChange,
  className = '',
  ...rest
}) {
  return (
    <input
      type="datetime-local"
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      className={[
        'block w-full',
        'bg-paper text-ink',
        'border border-rule rounded-md',
        'px-3 py-2',
        'text-base',
        'focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      ].join(' ')}
      {...rest}
    />
  );
}